import React, { useEffect } from "react";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import { Link } from "react-router-dom";
import { toAbsoluteUrl } from "../../helpers";
import { useEyeconxStore } from "../../../store/eyeconxStore";
import { KTSVG } from "../../helpers/KTSVG";

function EcxSidebar() {
  const sidebarCollapsed = useEyeconxStore((state) => state.sidebarCollapsed);
  const sidebarToggled = useEyeconxStore((state) => state.sidebarToggled);
  const sidebarBroken = useEyeconxStore((state) => state.sidebarBroken);
  const setSidebarCollapsed = useEyeconxStore(
    (state) => state.setSidebarCollapsed
  );
  const toggleSidebar = useEyeconxStore((state) => state.toggleSidebar);
  const setSidebarBroken = useEyeconxStore((state) => state.setSidebarBroken);

  useEffect(() => {
    console.log("Sidebar Collapsed");
    console.log(sidebarCollapsed);
  }, []);
  const themes = {
    light: {
      sidebar: {
        backgroundColor: "#ffffff",
        color: "#607489",
      },
      menu: {
        menuContent: "#fbfcfd",
        icon: "#0098e5",
        hover: {
          backgroundColor: "#c5e4ff",
          color: "#44596e",
        },
        disabled: {
          color: "#9fb6cf",
        },
      },
    },
    dark: {
      sidebar: {
        backgroundColor: "#1e1e2d",
        color: "#f5f5f5",
      },
      menu: {
        menuContent: "#1e1e2d",
        icon: "#ffffff",
        hover: {
          backgroundColor: "#1b1b28",
          color: "#f5f5f5",
        },
        disabled: {
          color: "#3e5e7e",
        },
      },
    },
  };
  // hex to rgba converter
  const hexToRgba = (hex, alpha) => {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);

    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  };

  const handleArrowClick = (e) => {
    e.currentTarget.classList.toggle("active");
    setSidebarCollapsed(!sidebarCollapsed);
  };
  const menuItemStyles = {
    root: {
      fontSize: "1.1rem",
      fontWeight: 600,
    },
    icon: {
      color: themes["dark"].menu.icon,
    },
    SubMenuExpandIcon: {
      color: "#b6b7b9",
    },
    subMenuContent: ({ level }) => ({
      backgroundColor:
        level === 0
          ? hexToRgba(
              themes["dark"].menu.menuContent,
              !sidebarCollapsed ? 0.4 : 1
            )
          : "transparent",
    }),
    button: {
      color: hexToRgba(themes["dark"].sidebar.color, 0.6),
      [`&.active`]: {
        backgroundColor: hexToRgba(
          themes["dark"].menu.hover.backgroundColor,
          1
        ),
        color: themes["dark"].menu.hover.color,
      },
      "&:hover": {
        backgroundColor: hexToRgba(
          themes["dark"].menu.hover.backgroundColor,
          1
        ),
        color: themes["dark"].menu.hover.color,
      },
    },
    label: ({ open }) => ({
      fontWeight: open ? 600 : undefined,
    }),
  };
  return (
    <Sidebar
      breakPoint="md"
      collapsed={sidebarCollapsed}
      toggled={sidebarToggled}
      onBreakPoint={setSidebarBroken}
      onBackdropClick={toggleSidebar}
      backgroundColor={hexToRgba(themes["dark"].sidebar.backgroundColor, 1)}
      rootStyles={{
        color: themes["dark"].sidebar.color,
        height: "100%",
      }}
    >
      <div
        className="d-flex flex-row justify-content-between align-items-center mb-10 mt-5"
        style={{ height: "64px", minHeight: "64px" }}
      >
        <div className="flex-fill">
          {!sidebarCollapsed ? (
            <div className="ms-3 bg-gray-500 rounded p-2">
              <img
                src={toAbsoluteUrl("/media/logos2/neweyeconxlogo.png")}
                className="w-100px"
                alt="EyeconX"
              />
            </div>
          ) : (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{
                width: "35px",
                minWidth: "35px",
                height: "35px",
                minHeight: "35px",
                borderRadius: "8px",
                color: "white",
                fontSize: "24px",
                fontWeight: "800",
                marginRight: "5px",
                marginLeft: "10px",
              }}
            >
              E
            </div>
          )}
        </div>
        <div className="me-2 rotate" onClick={handleArrowClick}>
          <KTSVG
            path="/media/icons/duotune/arrows/arr021.svg"
            className="svg-icon-2 rotate-180 ms-1 me-3"
          />
        </div>
      </div>
      <Menu menuItemStyles={menuItemStyles}>
        <MenuItem
          component={<Link to="dashboard" />}
          icon={
            <KTSVG
              path="/media/icons/duotune/general/gen008.svg"
              className="svg-icon-2"
            />
          }
        >
          {" "}
          Dashboard
        </MenuItem>
        <MenuItem
        component={<Link to="appointments" />}
          icon={
            <KTSVG
              path="/media/icons/duotune/general/gen066.svg"
              className="svg-icon-2"
            />
          }
        >
          {" "}
          Appointments
        </MenuItem>
        <MenuItem
        component={<Link to="patient-files" />}
          icon={
            <KTSVG
              path="/media/icons/duotune/general/gen067.svg"
              className="svg-icon-2"
            />
          }
        >
          {" "}
          Patient Files
        </MenuItem>
        <div
          style={{ padding: "0 5px", marginTop: "10px", marginBottom: "8px" }}
        >
          {sidebarCollapsed ? (
            <span style={{ padding: "0 24px" }}>
              <KTSVG
                path="/media/icons/duotune/general/gen052.svg"
                className="svg-icon-2"
              />
            </span>
          ) : (
            <span
              style={{
                fontWeight: "500",
                fontSize: "0.9rem",
                opacity: 0.4,
                letterSpacing: "0.5px",
              }}
            >
              COMMUNICATION TOOLS
            </span>
          )}
        </div>
        <MenuItem
        component={<Link to="messages" />}
          icon={
            <KTSVG
              path="/media/icons/duotune/communication/com007.svg"
              className="svg-icon-2"
            />
          }
        >
          {" "}
          Messages
        </MenuItem>
        <MenuItem
        component={<Link to="surveys" />}
          icon={
            <KTSVG
              path="/media/icons/duotune/general/gen068.svg"
              className="svg-icon-2"
            />
          }
        >
          {" "}
          Surveys
        </MenuItem>
        <MenuItem
         component={<Link to="articles" />}
          icon={
            <KTSVG
              path="/media/icons/duotune/general/gen005.svg"
              className="svg-icon-2"
            />
          }
        >
          {" "}
          Articles
        </MenuItem>
        <SubMenu
          label="Newsletter"
          icon={
            <KTSVG
              path="/media/icons/duotune/general/gen016.svg"
              className="svg-icon-2"
            />
          }
        >
          <MenuItem
             component={<Link to="newsletter/email-newsletter" />}
          >Email</MenuItem>
          <MenuItem
             component={<Link to="newsletter/sms-newsletter" />}
          >Sms</MenuItem>
        </SubMenu>
        <SubMenu
          label="Blast"
          icon={
            <KTSVG
              path="/media/icons/duotune/communication/com014.svg"
              className="svg-icon-2"
            />
          }
        >
          <MenuItem
             component={<Link to="blast/email" />}
          >Email</MenuItem>
          <MenuItem
             component={<Link to="blast/sms" />}
          >Sms</MenuItem>
        </SubMenu>
        <MenuItem
         component={<Link to="eye-draw" />}
          icon={
            <KTSVG
              path="/media/icons/duotune/general/gen003.svg"
              className="svg-icon-2"
            />
          }
        >
          Reputation
        </MenuItem>
        <MenuItem
         component={<Link to="eye-draw" />}
          icon={
            <KTSVG
              path="/media/icons/duotune/art/art007.svg"
              className="svg-icon-2"
            />
          }
        >
          Eye Draw
        </MenuItem>
        <div
          style={{ padding: "0 5px", marginTop: "10px", marginBottom: "8px" }}
        >
          {sidebarCollapsed ? (
            <span style={{ padding: "0 24px" }}>
              <KTSVG
                path="/media/icons/duotune/general/gen052.svg"
                className="svg-icon-2"
              />
            </span>
          ) : (
            <span
              style={{
                fontWeight: "500",
                fontSize: "0.9rem",
                opacity: 0.4,
                letterSpacing: "0.5px",
              }}
            >
              MISC
            </span>
          )}
        </div>

        <MenuItem 
          component={<Link to="activity/all" />} 
            icon={
            <KTSVG
            path="/media/icons/duotune/general/gen013.svg"
            className="svg-icon-2"
          /> 
          }>
                       My Activity
        </MenuItem>
      
        <MenuItem
         component={<Link to="my-files" />}
          icon={
            <KTSVG
              path="/media/icons/duotune/files/fil012.svg"
              className="svg-icon-2"
            />
          }
        >
          {" "}
          My Files
        </MenuItem>
        <SubMenu
          label="Settings"
          icon={
            <KTSVG
              path="/media/icons/duotune/general/gen019.svg"
              className="svg-icon-2"
            />
          }
        >
          <MenuItem
           component={<Link to="settings/clinic" />}
          >Clinic Information</MenuItem>
          <MenuItem
             component={<Link to="settings/reminders" />}
          >Reminders</MenuItem>
          <MenuItem>Email Templates</MenuItem>
          <MenuItem>Sms Templates</MenuItem>
          <MenuItem>Call Demos</MenuItem>
        </SubMenu>
      </Menu>
    </Sidebar>
  );
}

export default EcxSidebar;
